import { ICON_SIZES } from '@talos/kyoko';
import styled from 'styled-components';

export const PriceGridMarketDataActionsGrid = styled.span`
  display: grid;
  grid-template-columns: auto ${ICON_SIZES.MEDIUM}px auto;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing4}px;
`;

export const PriceGridMarketStatusIndicatorCell = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
